export default "__VITE_ASSET__BhS_fNLa__"